// extracted by mini-css-extract-plugin
module.exports = {"container":"LegendePlanning_container__31vkw"};